/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * API Сервиса Кошельки #wallets
 * API одного из сервисов проекта BloxWay. API сервиса "Кошельков" предназначено для работы с оплатами, промокодами, транзакциями и всеми связанными данными. Сервис предоставляет следующие возможности:

 - Работа с кошельками

 - Получение баланса кошелька

 - Пополнение баланса

 - Блокировка и разблокировка кошелька

 - История операций кошелька

 - Работа с оплатами

 - Получение методов оплаты

 - Проверка статуса оплаты

 - Отмена и возврат платежей

 - Работа с промокодами

 - Чтение промокодов

 - Создание и редактирование промокодов

 - Получение статистики по ним

 - Применение промокодов к заказам

 - Работа с транзакциями

 - Просмотр истории транзакций

 - Поиск транзакций по критериям

 - Анализ и отчетность по транзакциям


 # 🚀 Начало работы

 Эта коллекция проведет вас через операции CRUD (GET, POST, PUT, DELETE), переменные и тесты.

 # 💡 Ключевые знаки

 🔓 — обозначает, что маршрут требует доступа

 👮‍♂️ — обозначает, что маршрут требует особых прав на чтение или запись

 🤖 — обозначает, что маршрут требует сервисный ключ доступа (для внутренней коммуникации между сервисами)
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { BodyType, ErrorType } from '../../axios-client';
import { useCustomClient } from '../../axios-client';
import type { GetPaymentMethods200, PostPaymentMethodsBody } from '.././models';

/**
 * @summary Получать методы оплаты
 */
export const useGetPaymentMethodsHook = () => {
  const getPaymentMethods = useCustomClient<GetPaymentMethods200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getPaymentMethods({
        url: '/payment-methods',
        method: 'GET',
        signal,
      });
    },
    [getPaymentMethods],
  );
};

export const getGetPaymentMethodsQueryKey = () => {
  return ['/payment-methods'] as const;
};

export const useGetPaymentMethodsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPaymentMethodsQueryKey();

  const getPaymentMethods = useGetPaymentMethodsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>
  > = ({ signal }) => getPaymentMethods(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentMethodsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>
>;
export type GetPaymentMethodsQueryError = ErrorType<unknown>;

export function useGetPaymentMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Получать методы оплаты
 */

export function useGetPaymentMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetPaymentMethodsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary New Request
 */
export const usePostPaymentMethodsHook = () => {
  const postPaymentMethods = useCustomClient<unknown>();

  return useCallback(
    (
      postPaymentMethodsBody: BodyType<PostPaymentMethodsBody>,
      signal?: AbortSignal,
    ) => {
      return postPaymentMethods({
        url: '/payment-methods',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postPaymentMethodsBody,
        signal,
      });
    },
    [postPaymentMethods],
  );
};

export const usePostPaymentMethodsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostPaymentMethodsHook>>>,
    TError,
    { data: BodyType<PostPaymentMethodsBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostPaymentMethodsHook>>>,
  TError,
  { data: BodyType<PostPaymentMethodsBody> },
  TContext
> => {
  const mutationKey = ['postPaymentMethods'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const postPaymentMethods = usePostPaymentMethodsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostPaymentMethodsHook>>>,
    { data: BodyType<PostPaymentMethodsBody> }
  > = props => {
    const { data } = props ?? {};

    return postPaymentMethods(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPaymentMethodsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePostPaymentMethodsHook>>>
>;
export type PostPaymentMethodsMutationBody = BodyType<PostPaymentMethodsBody>;
export type PostPaymentMethodsMutationError = ErrorType<unknown>;

/**
 * @summary New Request
 */
export const usePostPaymentMethods = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostPaymentMethodsHook>>>,
    TError,
    { data: BodyType<PostPaymentMethodsBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePostPaymentMethodsHook>>>,
  TError,
  { data: BodyType<PostPaymentMethodsBody> },
  TContext
> => {
  const mutationOptions = usePostPaymentMethodsMutationOptions(options);

  return useMutation(mutationOptions);
};
